import React from 'react';
import { RadioGroup } from 'devextreme-react/radio-group';
import { userService } from '../../services/user.service';

const Discounts = ({ callback = undefined, value ="PVT1"}) => {

    const user = userService.getUser();
    const dataSource = ['Ninguno'];

    if(user.pvt1) dataSource.push('PVT1');
    if(user.pvt2) dataSource.push('PVT2');
    if(user.pvt3) dataSource.push('PVT3');
    if(user.pvt4) dataSource.push('PVT4');

    return (     
        <RadioGroup layout="horizontal" dataSource={dataSource} 
        value={value}
        onValueChanged={callback}  />
    );
}

export default Discounts;
